<template>
  <BaseFiltersSideBar
    v-model="model"
    @filters-submit="onFiltersSubmit"
  >
    <SaleInvoicesRetentionListFiltersForm
      ref="sale-invoices-retention-list-filters-form"
      v-model="filters"
      @submit="onFiltersSubmit"
    />
  </BaseFiltersSideBar>
</template>

<script>
import SaleInvoicesRetentionListFiltersForm from '@/components/sale-invoices/form/SaleInvoicesRetentionListFiltersForm.vue'
import BaseFiltersSideBar from '@/components/ui/sidebar/BaseFiltersSideBar.vue'

export default {
  name: 'SaleInvoicesRetentionListFilters',
  components: {
    BaseFiltersSideBar,
    SaleInvoicesRetentionListFiltersForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    baseFilters: {
      type: Object,
      default: false,
    }
  },
  data() {
    return {
      filters: {},
    }
  },
  computed: {
    model: {
      get() {
        if (this.value) {
          this.filters = this.baseFilters      
        }
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    clearFilters() {
      this.$refs['sale-invoices-retention-list-filters-form'].clearForm()
    },
    onFiltersSubmit() {
      this.model = false
      this.$emit('filters-submit', this.filters)
    },
  },
}
</script>
